// Shared enum value/label sets come from the server, not the client. The Rails
// AppEnums module (app/models/app_enums.rb) serializes them into
// <meta name="app-enums">; this reads + parses that once and caches it, so the
// dropdowns and pills never duplicate the lists that the model validations use.

// Cached for the page's lifetime — the meta tag is rendered once in the layout
// and never mutated (no SPA navigation swaps it).
let cache = null;

function load() {
  if (cache) return cache;
  const el = document.querySelector('meta[name="app-enums"]');
  if (!el || !el.content) {
    console.error('[enums] <meta name="app-enums"> is missing — enum lists will be empty');
    cache = {};
    return cache;
  }
  try {
    cache = JSON.parse(el.content);
  } catch (e) {
    // Degrade to empty rather than crashing the React island this is read from.
    console.error('[enums] failed to parse the app-enums payload', e);
    cache = {};
  }
  return cache;
}

// Ordered options for a key: [{ value, label }, ...]. Empty array if missing.
export function enumOptions(key) {
  return load()[key] || [];
}

// A { value: label } lookup for a key. Empty object if missing.
export function enumLabels(key) {
  return enumOptions(key).reduce((acc, { value, label }) => {
    acc[value] = label;
    return acc;
  }, {});
}
